import * as React from 'react';
import { cn } from '@/lib/utils';

const GuideReview = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-review',
      // Estilos base
      'flex flex-col items-center gap-4 p-5 text-center',
      'rounded-[10px] border border-solid border-neutral-lightest',
      'bg-[linear-gradient(180deg,#DDFAFF_0%,#E2F8FF_44%,#FFF8E1_87.5%)]',
      'shadow-card',
      'duration-[160ms] transition-all',
      // Estilos de hover e focus
      'hover:shadow-[0px_4px_10px_0px_rgba(93,106,134,0.16)]',
      'focus:shadow-[0px_4px_10px_0px_rgba(93,106,134,0.16)]',
      className
    )}
    {...props}
  />
));
GuideReview.displayName = 'GuideReview';

const GuideReviewBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-review',
      // Estilos base
      '',
      className
    )}
    {...props}
  />
));
GuideReviewBody.displayName = 'GuideReviewBody';

const GuideReviewTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-guide-review-title',
      // Estilos base
      'text-brand-primary-dark mb-0 text-2xl font-bold leading-none',
      className
    )}
    {...props}
  />
));
GuideReviewTitle.displayName = 'GuideReviewTitle';

const GuideReviewSubtitle = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-guide-review-subtitle',
      // Estilos base
      'text-lg font-bold text-neutral-dark',
      className
    )}
    {...props}
  />
));
GuideReviewSubtitle.displayName = 'GuideReviewSubtitle';

const GuideReviewText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-guide-review-text',
      // Estilos base
      'mb-0 text-base font-bold leading-none text-neutral-dark',
      className
    )}
    {...props}
  />
));
GuideReviewText.displayName = 'GuideReviewText';

const GuideReviewImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-guide-review-img',
      // Estilos base
      'max-h-[72px]',
      className
    )}
    {...props}
  />
));
GuideReviewImg.displayName = 'GuideReviewImg';

const GuideReviewImgWrapper = React.forwardRef(({ className, size, ...props }, ref) => (
  <figure
    ref={ref}
    className={cn(
      'c-guide-review-img-wrapper',
      // Estilos base
      'rounded-full bg-white',
      'aspect-square w-[104px]',
      'relative flex items-center justify-center',
      // Tamanhos
      size === 'sm' && 'w-[80px]',
      className
    )}
    {...props}
  />
));
GuideReviewImgWrapper.displayName = 'GuideReviewImgWrapper';

export { GuideReview, GuideReviewBody, GuideReviewTitle, GuideReviewSubtitle, GuideReviewText, GuideReviewImg, GuideReviewImgWrapper };
